var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"grey--text text-h4",attrs:{"cols":"auto"}},[_vm._v(" O prazo de inscrição está encerrado. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }